<div class="maintenance-container">
  <mat-card>
    <mat-card-subtitle>When DRC Portal is unavailable, you can use this password instead to login to this website.</mat-card-subtitle>

    <mat-card-content class="card-content">
      <div class="form-row">
        <form [formGroup]="passwordForm" (ngSubmit)="registerPassword()">
          <mat-form-field class="password-composite-field" id="loginPasswordFormField">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" [type]="passInputType" name="password" required>
            <mat-checkbox class="toggle-checkbox" matSuffix (click)="togglePasswordText()">Show Text</mat-checkbox>
          </mat-form-field>
          <button mat-button class="mat-small-button" style="margin:0 0 0 12px; height: 36px;" [disabled]="pForm.password.errors">Save</button>
          <span style="margin-left:24px;" [ngClass]="savestatus =='Success'? 'hassuccess': 'haserror'">{{savestatus}}</span>
          @if (inprogress) {
            <span clas="spinner"><mat-spinner diameter="15" ></mat-spinner> </span>
          }
        </form>
      </div>
      @if (pForm.password.errors) {
        <div>
          @if (passwordForm.get('password').hasError('required')) {
            <mat-error>Password cannot be empty. </mat-error>
          }
          @if (passwordForm.get('password').hasError('minlength')) {
            <mat-error>Minimum length should be 8 characters. </mat-error>
          }
          @if (passwordForm.get('password').hasError('maxlength')) {
            <mat-error>Maximum length should be 127 characters. </mat-error>
          }
          @if (passwordForm.get('password').hasError('pattern')) {
            <mat-error>Password must have a special, lowercase, uppercase and a numerical character.  ex. !&#64;#% </mat-error>
          }
        </div>
      }
      @if (isPasswordSet == true) {
        <div class="note-row">
          <span>Note: Your password has been already set. Still you can update your password.</span>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
